"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvailable = void 0;
function isTouchEnabled() {
    if (typeof window !== 'undefined') {
        return ('ontouchstart' in window ||
            !!(window['document'] && document.documentElement && 'ontouchstart' in document.documentElement) ||
            !!(window['navigator'] && window['navigator']['msMaxTouchPoints']));
    }
    else {
        return false;
    }
}
function isAvailable() {
    return !isTouchEnabled();
}
exports.isAvailable = isAvailable;
//# sourceMappingURL=mouse-pixel.js.map